import { Clickable, createComponent } from '@carvana/merch-components';
import styles from './ImageCarousel.module.css';

export const Section = createComponent('section', {
  className: `relative m-auto flex flex-col pb-48 m:py-48 l:py-80`
});

export const Title = createComponent('div', {
  className: `relative z-1 w-full p-32 text-center text-[28px] font-black uppercase tracking-tight text-blue-6 m:pb-12 m:pt-0 m:text-[40px] l:pb-24 l:pt-0 l:text-[54px]`
});

export const CarouselContainer = createComponent('div', {
  className: `relative flex justify-center overflow-visible`
});

export const CarouselWrapper = createComponent('div', {
  className: `${styles.wrapper} w-full m:w-[344px] m:max-w-[90%] l:relative l:w-[1238px]`
});

export const ImageWrapper = createComponent('div', {
  className: `relative w-full px-12 m:px-0`
});

export const CarouselImage = createComponent('img', {
  className: `relative h-[380px] w-full w-full transform rounded-xl object-cover transition-all duration-200 ease-in-out m:h-auto`
});

export const ArrowButton = createComponent(Clickable, {
  className:
    'absolute top-[calc(50%-40px)] hidden h-[80px] w-[80px] rounded-full bg-white shadow-legacy m:block'
});

export const IconWrapper = createComponent('div', {
  className: `flex h-full w-full items-center justify-center`
});
